<div
  fxLayout="row"
  fxLayoutAlign="start center">
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="checkbox mr-2">
    <div
      class=""></div>
    <div
      class="checkbox-input-wrapper"
      (click)="onCheckChanged()"
      [ngClass]="{ 'checked': checked && !indeterminate, 'indeterminate': indeterminate && !disabled, 'disabled': disabled }"
      role="presentation">
      <input
        class="checkbox-input"
        type="checkbox"
        tabindex="-1" />
    </div>
  </div>
</div>
